<template>
  <div class="sp-template plate-template order-plate-template">
    <div class="h-title">{{title}}</div>
    <el-card class="box-card">
      <el-form 
        :model="warehouseForm" 
        size="small" 
        status-icon 
        :rules="rules" 
        ref="warehouseForm"
        class="new-order__form"
        :label-width="operate === 'look' ? '130px' : '120px'">
        <!-- 基本信息 -->
        <div class="plate-content">
          <div class="plate-content__title">
            <span class="title">基本信息</span>
          </div>
          <!-- 查看 -->
          <div class="view-customer" v-if="operate === 'look'">
            <el-form-item label="仓库名称：">{{warehouseForm.name}}</el-form-item>
            <el-form-item label="国家：">{{warehouseForm.warehouseAddress.countryCode}}</el-form-item>
            <el-form-item label="州/省：">{{warehouseForm.warehouseAddress.province}}</el-form-item>
            <el-form-item label="城市：">{{warehouseForm.warehouseAddress.city}}</el-form-item>
            <el-form-item label="街道地址：">{{warehouseForm.warehouseAddress.address}}</el-form-item>
            <el-form-item label="地址2：">{{warehouseForm.street}}</el-form-item>
            <el-form-item label="邮编：">{{warehouseForm.warehouseAddress.postCode}}</el-form-item>
            <!-- <el-form-item label="坐标：">{{warehouseForm.warehouseAddress.position}}</el-form-item> -->
            <el-form-item label="尺寸(m)：">
              <span>长：{{warehouseForm.length}}</span>
              <span>宽：{{warehouseForm.width}}</span>
              <span>高：{{warehouseForm.height}}</span>
            </el-form-item>
          </div>
          <!-- 编辑 -->
          <div v-else>
            <div class="inline-flex">
              <div>
                <el-form-item label="仓库名称：" prop="name">
                  <el-input v-model.lazy="warehouseForm.name" placeholder="仓库名称"></el-input>
                </el-form-item>
                <el-form-item label="州/省：" prop="province">
                  <el-select v-model.lazy="warehouseForm.warehouseAddress.province" filterable @change="getProvince">
                    <el-option v-for="item in province" :key="item.id" :label="item.nameEn" :value="item.nameEn"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮编：" prop="postCode">
                  <el-input v-model.lazy="warehouseForm.warehouseAddress.postCode" placeholder="邮编"></el-input>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="国家：" prop="countryCode">
                  <el-select v-model.lazy="warehouseForm.warehouseAddress.countryCode" filterable @change="getCountry">
                    <el-option v-for="item in countryCode" :key="item.id" :label="item.nameEn" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="城市：" prop="city">
                  <el-select v-model.lazy="warehouseForm.warehouseAddress.city" filterable>
                    <el-option v-for="item in city" :key="item.id" :label="item.nameEn" :value="item.nameEn"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="坐标："  prop="position">
                  <el-input v-model.lazy="warehouseForm.warehouseAddress.position" placeholder="坐标" class="width80"></el-input>
                  <el-button type="text" size="mini" @click="handleMapEdit">获取坐标</el-button>
                </el-form-item> -->
              </div>
            </div>
            <div class="pickup-content">
                <el-form-item label="街道地址：" prop="address">
                  <el-input v-model.lazy="warehouseForm.warehouseAddress.address" placeholder="街道地址"></el-input>
                </el-form-item>
              </div>
              <div class="pickup-content">
                <el-form-item label="地址2：">
                  <el-input v-model.lazy="warehouseForm.street" placeholder="地址2"></el-input>
                </el-form-item>
              </div>
              <div class="pickup-content">
                <el-form-item label="尺寸(m)：" prop="size">
                  <el-input v-model.lazy="warehouseForm.length" class="width-130" placeholder="长"></el-input>
                  <el-input v-model.lazy="warehouseForm.width" class="width-130" placeholder="宽"></el-input>
                  <el-input v-model.lazy="warehouseForm.height" class="width-130" placeholder="高"></el-input>
                </el-form-item>
              </div>
          </div>
        </div>
        <!-- 联系信息 -->
        <div class="plate-content">
          <div class="plate-content__title">
            <span class="title">联系信息</span>
          </div>
          <!-- 查看 -->
          <div class="view-customer" v-if="operate === 'look'">
            <el-form-item label="仓库电话：">{{warehouseForm.phone}}</el-form-item>
            <el-form-item label="仓库联系人：">{{warehouseForm.managePersonName}}</el-form-item>
            <el-form-item label="仓库联系人电话：">{{warehouseForm.managePersonPhone}}</el-form-item>
            <el-form-item label="收货联系人：">{{warehouseForm.receiptPersonName}}</el-form-item>
            <el-form-item label="收货联系人电话：">{{warehouseForm.receiptPersonPhone}}</el-form-item>
          </div>
          <!-- 编辑 -->
          <div v-else>
            <el-form-item label="仓库电话：" prop="phone">
              <el-input v-model.lazy="warehouseForm.phone" placeholder="仓库电话"></el-input>
            </el-form-item>
            <div class="inline-flex">
              <div>
                <el-form-item label="仓库联系人：">
                  <el-input v-model.lazy="warehouseForm.managePersonName" placeholder="仓库联系人"></el-input>
                </el-form-item>
                <el-form-item label="收货联系人：">
                  <el-input v-model.lazy="warehouseForm.receiptPersonName" placeholder="收货联系人"></el-input>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="电话：" prop="managePersonPhone">
                  <el-input v-model.lazy="warehouseForm.managePersonPhone" placeholder="仓库联系人电话" 
                  @blur="checkManagePhone" :class="isManagePhone ? 'error' : ''"></el-input><br/>
                  <span v-if="isManagePhone" style="color: #f56c6c; font-size: 12px;">{{error}}</span>
                </el-form-item>
                <el-form-item label="电话：" prop="receiptPersonPhone">
                  <el-input v-model.lazy="warehouseForm.receiptPersonPhone" placeholder="收货联系人电话" 
                  @blur="checkReceiptPhone" :class="isReceiptPhone ? 'error' : ''"></el-input><br/>
                  <span v-if="isReceiptPhone" style="color: #f56c6c; font-size: 12px;">{{error2}}</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!-- 其他信息 -->
        <div class="plate-content">
          <div class="plate-content__title">
            <span class="title">其它信息</span>
          </div>
          <!-- 查看 -->
          <div class="view-customer" v-if="operate === 'look'">
            <el-form-item label="所属时区：">{{warehouseForm.timeZone}}</el-form-item>
            <el-form-item label="货币：">{{warehouseForm.currency}}</el-form-item>
            <el-form-item label="发货分单：">{{warehouseForm.splitOrderDelivery ? "是": "否"}}</el-form-item>
            <el-form-item label="部分收货：">{{warehouseForm.partReceipt ? "是": "否"}}</el-form-item>
            <el-form-item label="是否虚拟仓：">{{warehouseForm.virtual ? "是": "否"}}</el-form-item>
            <el-form-item label="备注：">{{warehouseForm.remarks}}</el-form-item>
          </div>
          <div v-else>
            <div class="inline-flex">
              <el-form-item label="发货分单：">
                <el-switch v-model.lazy="warehouseForm.splitOrderDelivery"></el-switch>
              </el-form-item>
              <el-form-item label="是否虚拟仓：">
                <el-switch v-model.lazy="warehouseForm.virtual"></el-switch>
              </el-form-item>
              <el-form-item label="部分收货：">
                <el-switch v-model.lazy="warehouseForm.partReceipt"></el-switch>
              </el-form-item>
            </div>
            <div class="inline-flex">
              <div>
                <el-form-item label="所属时区：" prop="timeZone">
                  <el-select v-model.lazy="warehouseForm.timeZone">
                    <el-option value="Asia/Shanghai">Asia/Shanghai</el-option>
                    <el-option value="Asia/Hong_Kong">Asia/Hong_Kong</el-option>
                    <el-option value="America/Los_Angeles">America/Los_Angeles</el-option>
                    <el-option value="Europe/Berlin">Europe/Berlin</el-option>
                    <el-option value="Europe/Amsterdam">Europe/Amsterdam</el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="货币：" prop="currency">
                  <el-select v-model.lazy="warehouseForm.currency">
                    <el-option value="CNY">人民币(CNY)</el-option>
                    <el-option value="HKD">港币(HKD)</el-option>
                    <el-option value="USD">美元(USD)</el-option>
                    <el-option value="EUR">欧元(EUR)</el-option>
                    <el-option value="JPY">日元(JPY)</el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="备注：">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model.lazy="warehouseForm.remarks"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </el-card>
    <div class="submit-buttons">
      <el-button @click="back">返 回</el-button>
      <el-button v-if="operate !== 'look'" type="primary" @click="submitWarehouseForm('warehouseForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkWarehouseName = (rule, value, callback) => {
      if (this.operate === 'edit') {
        let warehouseName = JSON.parse(decodeURIComponent(this.$route.query.row)).name
        if (value == warehouseName) {
          callback();
          return;
        }
      }

      this.$request1({
        method: 'GET',
        url: '/warehouse/check',
        params: { name: value }
      })
        .then(response => {

          if (response.data.success) {
            callback();
          } else {
            callback(new Error("仓库名称已存在"));
          }
        })
        .catch(error => {

        });
    };
    var countryCodeCheck = (rule, value, callback) => {
      if (this.warehouseForm.warehouseAddress.countryCode == "") {
        callback(new Error("请选择国家"));
      } else {
        callback();
      }
    };
    var provinceCheck = (rule, value, callback) => {
      if (this.warehouseForm.warehouseAddress.province == "") {
        callback(new Error("请选择州或省"));
      } else {
        callback();
      }
    };
    var cityCheck = (rule, value, callback) => {
      if (this.warehouseForm.warehouseAddress.city == "") {
        callback(new Error("请选择城市"));
      } else {
        callback();
      }
    };
    var addressCheck = (rule, value, callback) => {
      if (this.warehouseForm.warehouseAddress.address == "") {
        callback(new Error("请填写街道地址"));
      } else {
        callback();
      }
    };
    var postCodeCheck = (rule, value, callback) => {
      let ref = /^[0-9]{6}$/;
      if (this.warehouseForm.warehouseAddress.postCode == "") {
        callback(new Error("请填写邮政编码"));
      } else if (!ref.test(this.warehouseForm.warehouseAddress.postCode)) {
        callback(new Error("邮政编码格式不正确，请填写6位数值的邮政编码"));
      } else {
        callback();
      }
    };
    var sizeCheck = (rule, value, callback) => {
      let ref = /(^[1-9]([0-9]+)?(\.[0-9]+)?$)/;
      if (!ref.test(this.warehouseForm.length)) {
        callback(new Error("长应为大于0的数字"));
      } else if (!ref.test(this.warehouseForm.width)) {
        callback(new Error("宽应为大于0的数字"));
      } else if (!ref.test(this.warehouseForm.height)) {
        callback(new Error("高应为大于0的数字"));
      } else {
        callback();
      }
    };
    return {
      operate: 'new',
      title: "新建仓库",
      formLabelWidth: "120px",
      countryCode: [],
      province: [],
      city: [],
      error: "",
      error2: "",
      isManagePhone: false,
      isReceiptPhone: false,
      warehouseForm: {
        id: "",
        name: "",
        warehouseAddress: {
          countryCode: "",
          province: "",
          city: "",
          address: "",
          postCode: "",
          position: ""
        },
        street: "",
        phone: "",
        length: "",
        height: "",
        width: "",
        managePersonName: "",
        managePersonPhone: "",
        receiptPersonName: "",
        receiptPersonPhone: "",
        timeZone: "",
        currency: "",
        remarks: "",
        splitOrderDelivery: false,
        virtual: false,
        enable: false,
        partReceipt: false
      },
      rules: {
        name: [
          { required: true, message: "请填写仓库名称", trigger: "blur" },
          { validator: checkWarehouseName, trigger: "blur" }
        ],
        countryCode: [
          { required: true, validator: countryCodeCheck, trigger: "change" }
        ],
        province: [
          { required: true, validator: provinceCheck, trigger: "change" }
        ],
        city: [{ required: true, validator: cityCheck, trigger: "change" }],
        address: [{ required: true, validator: addressCheck, trigger: "blur" }],
        postCode: [
          { required: true, validator: postCodeCheck, trigger: "blur" }
        ],
        size: [{ required: true, validator: sizeCheck, trigger: "blur" }],
        phone: [
          { required: true, message: "请填写仓库电话", trigger: "blur" }
          // {
          //   pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{6,8}$/,
          //   message: "请输入正确的电话格式",
          //   trigger: "blur"
          // }
        ],
        timeZone: [
          { required: true, message: "请选择所属时区", trigger: "change" }
        ],
        currency: [{ required: true, message: "请选择货币", trigger: "change" }]
      },
    }
  },
  created() {
    setTimeout(() => {
      if(this.$route.query.operate) {
        this.operate = this.$route.query.operate
        switch(this.operate) {
          case 'new':
            this.title = '新建仓库'
            this.initCountry()
            break
          case 'edit':
            this.title = '编辑仓库'
            let row = JSON.parse(decodeURIComponent(this.$route.query.row))
            if(row) {
              this.queryDetailData(row);
              this.editWarehouseCountry(row)
            } else{
              this.$notify({
                title: '警告',
                message: '获取仓库信息失败！',
                type: 'warning'
              });
            }
            break
          case 'look':
            this.title = '查看仓库信息'
            let data = JSON.parse(decodeURIComponent(this.$route.query.row))
            if(data) {
              this.queryDetailData(data);
            } else{
              this.$notify({
                title: '警告',
                message: '获取仓库信息失败！',
                type: 'warning'
              });
            }
            break
        }
      }
    }, 500)
  },
  methods: {
    editWarehouseCountry(row) {
      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
      .then(response => {
        this.countryCode = response.data.data;
        let countryId = "";
        let code = row.warehouseAddress.countryCode;
        for (let i = 0; i < this.countryCode.length; i++) {
          if (this.countryCode[i].code == code) {
            countryId = this.countryCode[i].id;
          }
        }

        this.$request1({
          type: "GET",
          url: '/province/' + countryId + '',
          xhrFields: {
            withCredentials: true
          },
          params: {}
        })
          .then(response => {
            this.province = response.data.data;
            let provinceId = "";
            let nameEn = this.warehouseForm.warehouseAddress.province;
            for (let i = 0; i < this.province.length; i++) {
              if (this.province[i].nameEn == nameEn) {
                provinceId = this.province[i].id;
              }
            }
            this.$request1({
              type: "GET",
              url: '/city/' + provinceId + '',
              xhrFields: {
                withCredentials: true
              },
              params: {}
            })
              .then(response => {
                this.city = response.data.data;
              })
              .catch(error => {

              });
          })
          .catch(error => {

          });
      })
      .catch(error => {

      });
    },
    // 获取国家列表
    initCountry() {
      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
      .then(response => {
        this.countryCode = response.data.data;
      })
      .catch(error => {

      });
    },
    // 当选中国家后
    getCountry() {
      this.warehouseForm.warehouseAddress.province = "";
      this.warehouseForm.warehouseAddress.city = "";
      this.province = [];
      this.city = [];

      // 获取选择的国家id
      let countryId = "";
      let code = this.warehouseForm.warehouseAddress.countryCode;

      for (let i = 0; i < this.countryCode.length; i++) {
        if (this.countryCode[i].code == code) {
          countryId = this.countryCode[i].id;
        }
      }

      if (countryId == "") {
        return;
      }
      this.initProvince(countryId);
    },
    // 获取省份列表
    initProvince(countryId) {
      this.$request1({
        type: "GET",
        url: '/province/' + countryId + '',
        xhrFields: {
          withCredentials: true
        },
        params: {}
      })
        .then(response => {
          this.province = response.data.data;
        })
        .catch(error => {

        });
    },
    // 当选择州或省后
    getProvince() {
      this.warehouseForm.warehouseAddress.city = "";
      this.city = [];

      // 获取选择的州或省id
      let provinceId = "";
      let nameEn = this.warehouseForm.warehouseAddress.province;
      for (let i = 0; i < this.province.length; i++) {
        if (this.province[i].nameEn == nameEn) {
          provinceId = this.province[i].id;
        }
      }

      if (provinceId == "") {
        return;
      }

      // 获取城市列表
      this.$request1({
        type: "GET",
        url: '/city/' + provinceId + '',
        xhrFields: {
          withCredentials: true
        },
        params: {}
      })
      .then(response => {
        this.city = response.data.data;
      })
      .catch(error => {

      });
    },
    checkManagePhone() {
      // let ref = /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{6,8}$/;
      if (this.warehouseForm.managePersonPhone == "") {
        this.error = "";
        this.isManagePhone = false;
        return;
      } 
      // else if (!ref.test(this.warehouseForm.managePersonPhone)) {
      //   this.error = "请输入正确的电话格式";
      //   this.isManagePhone = true;
      //   return;
      // }
      this.error = "";
      this.isManagePhone = false;
    },
    checkReceiptPhone() {
      // let ref = /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{6,8}$/;
      if (this.warehouseForm.receiptPersonPhone == "") {
        this.error2 = "";
        this.isReceiptPhone = false;
        return;
      } 
      // else if (!ref.test(this.warehouseForm.receiptPersonPhone)) {
      //   this.error2 = "请输入正确的电话格式";
      //   this.isReceiptPhone = true;
      //   return;
      // }
      this.error = "";
      this.isReceiptPhone = false;
    },
    submitWarehouseForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$request1({
            method: 'post',
            url: '/warehouse',
            data: this.warehouseForm,
            xhrFields: {
              withCredentials: true
            },
            contentType: "application/json"
          })
            .then(response => {
              this.$refs[formName].resetFields();
              this.emptyForm();
              this.success();
              this.$router.push('/warehouse/warehouse')
            })
            .catch(error => {

              this.$message.error("操作失败");
            });
        } else {

          return false;
        }
      });
    },
    //清空表单数据
    emptyForm() {
      this.warehouseForm.id = "";
      this.warehouseForm.name = "";
      this.warehouseForm.warehouseAddress.countryCode = "";
      this.warehouseForm.warehouseAddress.province = "";
      this.warehouseForm.warehouseAddress.city = "";
      this.warehouseForm.warehouseAddress.address = "";
      this.warehouseForm.warehouseAddress.postCode = "";
      this.warehouseForm.warehouseAddress.position = "";
      this.warehouseForm.street = "";
      this.warehouseForm.phone = "";
      this.warehouseForm.length = "";
      this.warehouseForm.height = "";
      this.warehouseForm.width = "";
      this.warehouseForm.managePersonName = "";
      this.warehouseForm.managePersonPhone = "";
      this.warehouseForm.receiptPersonName = "";
      this.warehouseForm.receiptPersonPhone = "";
      this.warehouseForm.timeZone = "";
      this.warehouseForm.currency = "";
      this.warehouseForm.remarks = "";
      this.countryCode = "";
      this.province = "";
      this.city = "";
      this.warehouseForm.splitOrderDelivery = false;
      this.warehouseForm.virtual = false;
      this.warehouseForm.partReceipt = false;
      this.dialogFormVisible = false;
      this.isManagePhone = false;
      this.isReceiptPhone = false;
      this.error = "";
      this.error2 = "";
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    back() {
      this.close("warehouseForm")
      this.$router.push('/warehouse/warehouse')
    },
    //清除验证
    close(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    
    queryWarehouseData() {
      this.$request1({
        method: 'GET',
        url: '/warehouse/query',
        params: {
          currentPage: this.currentPage,
          pageSize: this.pageSize
        },
        xhrFields: {
          withCredentials: true
        }
      })
      .then(response => {
        this.warehouseData = response.data.data;
        this.total = response.data.total;
      })
      .catch(error => {

      });
    },
    //仓库明细
    queryDetailData(row) {
      for(let key in row) {
        this.warehouseForm[key] = row[key]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.inline-flex{
  display: flex; 
  flex-wrap: wrap;
  >:first-child{
    margin-right: 15px;
  }
}
</style>





// WEBPACK FOOTER //
// src/views/warehouse/NewWarehouse.vue